import { render, staticRenderFns } from "./GuildsList.vue?vue&type=template&id=0e0b34d1&"
import script from "./GuildsList.vue?vue&type=script&lang=js&"
export * from "./GuildsList.vue?vue&type=script&lang=js&"
import style0 from "./GuildsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports